/**
 * ProgressBar — determinate progress meter (sent / total, percent done…).
 *
 *   <ProgressBar value={processed} max={total} variant="success" label="Progres pengiriman" />
 *
 * Renders a native <progress>, so the fill width needs no inline style.
 * `variant`: 'primary' | 'success' | 'warning' | 'danger'. `size`: 'sm' | 'md' | 'lg'.
 * `value` is clamped to [0, max]; a missing/zero `max` renders an empty bar.
 */
export default function ProgressBar({
  value = 0,
  max = 100,
  variant = 'primary',
  size = 'md',
  label,
  className = '',
}) {
  const safeMax = max > 0 ? max : 1;
  const safeValue = Math.min(Math.max(Number(value) || 0, 0), safeMax);

  return (
    <progress
      className={`progress-bar progress-bar--${variant} progress-bar--${size} ${className}`.trim()}
      value={safeValue}
      max={safeMax}
      aria-label={label}
    />
  );
}
